import { localTable } from "@eusoft/webapp-framework";
import "@eusoft/webapp-framework/lang/IT";

localTable.add({
    "java.io.IOException": "Errore I/O Carta",
    "[all]": "[Tutti]",
    "[no-group]": "[Non raggruppare]",
    "[none-male]": "[Nessuno]",
    "[select]": "[Seleziona]",
    "accept-access-request": "Accetta richiesta",
    "accept-privacy": "Ho preso visione e accetto [l'informativa sulla privacy](/Privacy)",
    "account-details": "Dettagli",
    "account-type": "Tipo account",
    "accounting": "Contabilità",
    "active": "Attiva",
    "active-catalog-id": "Menù attivo",
    "add-format": "Aggiungi formato",
    "add-new": "Crea nuovo",
    "add-product": "Aggiungi prodotto",
    "address": "Indirizzo",
    "all": "Tutti",
    "all-amount": "Tutto l'importo residuo",
    "amount": "Importo",
    "anonymous": "Anonima",
    "app-name": "PayApp",
    "archived": "Archiviato",
    "attention": "Attenzione",
    "authorizations": "Autorizzazioni",
    "balance": "Saldo",
    "bank-card": "Bancomat",
    "bank-transfer": "Bonifico",
    "bill-address": "Indirizzo fatturazione",
    "birth-date": "Data di nascita",
    "block-card": "Blocca Carta",
    "blocked": "Bloccata",
    "blocked-on": "Bloccata il",
    "browser": "Browser",
    "business": "Attività / associazione",
    "business-group": "Gruppo attività/associazioni",
    "buy": "Vendita",
    "cancel": "Annulla",
    "cancelled": "Annullato",
    "card": "Carta",
    "card-code": "Codice Carta",
    "card-details": "Controlla Saldo",
    "card-list": "Gestisci Carte",
    "card-number": "Numero",
    "card-number-full": "Numero carta",
    "card-refund": "Rimborso",
    "card-state": "Stato",
    "card-write-error": "Errore durante la scrittura sulla carta",
    "cards": "Carte",
    "cash": "Contanti",
    "catalog": "Menu/Listino",
    "catalog-list": "Listini/Menu",
    "changed": "Modificato",
    "charge": "Ricarica",
    "charge-card": "Ricarica Carta",
    "check-balance": "Controlla saldo",
    "check-balance-card": "Controlla Saldo",
    "check-new": "Controlla nuova carta",
    "city": "Città",
    "clear-filter": "Pulisci filtro",
    "close": "Chiudi",
    "close-sessions": "Chiudi sessioni",
    "close-wallet": "Chiudi il conto",
    "closed": "Chiuso",
    "code": "Codice",
    "color": "Colore",
    "company-name": "Ragione sociale",
    "confirm": "Conferma",
    "continue": "Continua",
    "conversion-currency": "Valuta di conversione",
    "conversion-rate": "Tasso conversione",
    "copy": "Copia",
    "country": "Nazione",
    "create-item": "Crea {0}",
    "create-now": "Crea ora",
    "create-order": "Crea ordine",
    "create-sale-circuit": "Crea circuito pagamento",
    "created": "Creato",
    "credentials": "Credenziali",
    "currency-name": "Nome valuta",
    "current": "Corrente",
    "customer": "Cliente",
    "customer-email": "Email cliente",
    "customer-mobile-number": "Cellulare cliente",
    "customer-name": "Nome cliente",
    "customer-request": "Richiesto dal cliente",
    "date": "Data",
    "date-from": "Dal {0}",
    "date-range": "Dal {0} al {1}",
    "date-to": "Fino al {0}",
    "day": "Giorno",
    "days": "Giorni",
    "delegate": "Delega",
    "delegate-device": "Delega dispositivo",
    "delete": "Elimina",
    "desc-card-details": "Visualizza i dettagli della carta",
    "desc-card-list": "Gestisci le carte del circuito",
    "desc-init-card": "Inizializza una nuova carta",
    "desc-order-list": "Visualizza le transazioni del circuito",
    "desc-recharge-card": "Aggiungi credito alla carta",
    "desc-refund-card": "Rimborsa il credito della carta",
    "desc-sale-circuit-options": "Opzioni circuito di vendita",
    "desc-toggle-theme": "Imposta il tema dell'applicazione chiaro o scuro",
    "description": "Descrizione",
    "device": "Dispositivo",
    "device-list": "Dispositivi",
    "dimension": "Dimensione",
    "edit": "Modifica",
    "edit-item": "{edit} {0}",
    "email": "E-mail",
    "emitted-in": "Emessa da",
    "emitted-on": "Emessa il",
    "err-card-already-init": "Carta già inizializzata",
    "err-card-blocked": "Carta bloccata",
    "err-card-has-balance": "La nuova carta ha ancora {0}. Usare una carta vuota",
    "err-card-not-active": "Carta non attiva",
    "err-card-not-blocked": "Vecchia carta non bloccata",
    "err-card-not-refundable-balance": "La carta non è rimborsabile:\n\n \n\n - Credito residuo: **{0}**\n\n - Rimborsabile: **{1}**",
    "err-card-token-burned": "Token della carta bruciato",
    "err-expired": "Richiesta scaduta",
    "err-expired-otp": "OTP scaduto",
    "err-expired-time-for-pin-reset": "Tempo scaduto per il reset del PIN.",
    "err-field-greater-equals": "Il valore deve essere maggiore o uguale a {1}",
    "err-field-less-equals": "Il valore deve essere minore o uguale a {1}",
    "err-field-required": "Campo obbligatorio",
    "err-from-wallet-not-active": "Portafoglio di origine non attivo",
    "err-in-use": "Elemento in uso",
    "err-insufficient-credit": "Credito insufficiente, credito residuo: {0}",
    "err-invalid-account-type": "Tipo account non valido",
    "err-invalid-amount": "Importo non valido",
    "err-invalid-card-token": "Token carta non valido",
    "err-invalid-email": "Email non valida",
    "err-invalid-link-for-pin-reset": "Indirizzo non valido per il reset del PIN.",
    "err-invalid-login": "Utente o password non validi",
    "err-invalid-order-status": "Stato ordine non valido",
    "err-invalid-otp": "OTP non valido",
    "err-invalid-payment-token": "Token di pagamento non valido",
    "err-invalid-pin": "Pin non valido",
    "err-invalid-qr": "Codice QR non valido",
    "err-invalid-session": "La sessione non è valida o è scaduta",
    "err-invalid-signature": "Firma non valida",
    "err-invalid-state": "Stato non valido",
    "err-key-already-exists": "Chiave già esistente",
    "err-must-check": "Accettazione obbligatoria",
    "err-ndef-not-supported": "La carta non supporta NDEF / NFC",
    "err-negative-total": "Il totale dell'ordine non può essere negativo",
    "err-newcard-not-empty": "La nuova carta non è vuota",
    "err-no-device": "Dispositivo non trovato o non registrato",
    "err-no-enough-space": "Spazio insufficiente sulla carta",
    "err-no-session": "Sessione non trovata",
    "err-no-signature": "Firma non trovata",
    "err-not-authorized": "Non autorizzato",
    "err-not-found": "Non trovato",
    "err-old-new-cards-equals": "La nuova carta coincide con la vecchia carta",
    "err-order-update-failed": "Aggiornamento ordine fallito",
    "err-otp-resend-too-soon": "Rinvia OTP non disponibile. Attendere 60 secondi prima di richiedere un nuovo invio",
    "err-otp-verification-failed": "Verifica OTP fallita",
    "err-pay-token": "Errore durante la generazione del token di pagamento",
    "err-pay-token-device": "Il dispositivo non ha generato un token di pagamento valido, riprova",
    "err-request-reset-otp": "Errore durante la richiesta di reset PIN",
    "err-reset-failed": "Reset vecchia carta fallito",
    "err-sale-circuit-not-active": "Circuito vendita non attivo",
    "err-sale-point-not-enabled": "Punto vendita non abilitato",
    "err-server-unknown": "Impossibile connettersi al server. Assicurarsi di avere connessione ad internet",
    "err-service-unavailable": "Servizio non disponibile. Se il problema persiste contattare il supporto tecnico",
    "err-tag-read-only": "La carta è in sola lettura",
    "err-timeout": "Tempo scaduto per completare l'operazione",
    "err-to-wallet-not-active": "Portafoglio di destinazione non attivo",
    "err-wallet-blocked": "Portafoglio bloccato",
    "error": "Errore",
    "execute": "Esegui",
    "expire-time": "Scadenza entro",
    "extinction": "Estinzione",
    "field-select": "<seleziona>",
    "filter": "Filtro",
    "finish": "Fine",
    "first-name": "Nome",
    "format-date-time": "{D} {MMM} {YY} - {hh}:{mm}",
    "formats": "Formati",
    "fr-bottle": "Bottiglia",
    "fr-can": "Lattina",
    "fr-glass": "Bicchiere",
    "fr-large": "Grande",
    "fr-medium": "Media/o",
    "fr-small": "Piccola/o",
    "fr-tap": "Spina",
    "fr-unique": "Unico",
    "franchise": "Franchise",
    "fraudulent": "Frode/Truffa",
    "from-date": "da",
    "from-date-art": "dal",
    "full-name": "Nome completo",
    "general": "Generale",
    "gift": "Regalo",
    "group-by": "Raggruppa per",
    "group-by-time": "Intervallo tempo",
    "has-address": "Con indirizzo",
    "history": "Cronologia",
    "home": "Home",
    "home-cards": "Carte",
    "hour": "Ora",
    "init-card": "{Inizializza} carta",
    "init-new-card": "Inizializza nuova carta",
    "initialize": "Inizializza",
    "italy": "Italia",
    "item-with-info": "{0} ({1})",
    "items": "Elementi",
    "last-name": "Cognome",
    "last-operation": "Ultima operazione",
    "last-transactions": "Ultime transazioni",
    "log-out": "Disconnetti",
    "login": "Accedi",
    "login-wallet": "Inserisci pin",
    "main-address": "Indirizzo principale",
    "make-primary": "Rendi dispositivo principale",
    "manifestation": "Manifestazione",
    "merchant": "Commerciante",
    "merchant-data": "Dati commerciante",
    "merchant-details": "Dettagli venditore",
    "method": "Metodo",
    "minutes": "Minuti",
    "month": "Mese",
    "msg-access-verify": "Verifica invito accesso in corso...",
    "msg-account-created": "Complimenti, il tuo account è stato creato con successo!",
    "msg-balance-refundable-different": "Il credito rimborsabile {1} è minore del credito disponibile {0}",
    "msg-card-blocked-warning": "La carta è bloccata, vuoi procedere comunque?",
    "msg-card-has-balance": "La carta ha ancora **{0}** residui",
    "msg-card-init-complete": "Carta inizializzata con successo",
    "msg-card-replaced": "Carta sostituita con successo. Codice nuova carta {0}",
    "msg-card-unblocked": "Carta sbloccata",
    "msg-catalog-saved": "Menù salvato",
    "msg-confirm-block": "Confermare il blocco della carta?",
    "msg-confirm-close-sessions": "Tutte le {0} sessioni aperte dal dispositivo saranno terminate. Continuare?",
    "msg-confirm-delete": "Confermi l'eliminazione dell'elemento selezionato?",
    "msg-confirm-replace": "Vuoi sostituire questa carta con una nuova?",
    "msg-conversion": "1 {0} vale {2} {1}",
    "msg-create-merchant": "Crea un nuovo commerciante",
    "msg-device-must-be-secure": "PayApp richiede che il dispositivo sia protetto con schermata di blocco. Abilitare uno dei metodi di sblocco (pin/codice/impronta)",
    "msg-else-share-access": "Altrimenti, condividi il link di accesso",
    "msg-existing-merchant": "Usa commerciante esistente",
    "msg-insert-sale-point": "Inserire un punto vendita ora?",
    "msg-invalid-code": "Codice non valido",
    "msg-invite-title": "Nuovo invito su {app-name}",
    "msg-mail-sent": "E' stata inviata un'email a **{0}** con il codice di verifica.",
    "msg-no-active-session": "Nessuna sessione attiva trovata",
    "msg-no-cards": "Nessuna carta attivata",
    "msg-no-catalog": "Nessun menu/listino inserito",
    "msg-no-orders": "Nessun ordine trovato",
    "msg-no-printers": "Nessuna stampante disponibile",
    "msg-no-product": "Nessun prodotto inserito",
    "msg-no-sale-circuit": "Non hai ancora creato un circuito di vendita",
    "msg-no-sale-point": "Non hai ancora creato un punto di vendita",
    "msg-no-selection-all-sp": "Nessuna selezione implica tutti i punti vendita",
    "msg-operation-completed": "Operazione completata con successo",
    "msg-order-payed-amount": "Ordine pagato con successo.\nNuovo saldo: {0}",
    "msg-otp-not-received": "Non hai ricevuto il codice OTP? Controlla la cartella spam o chiedi un nuovo invio",
    "msg-otp-sent": "OTP inviato con successo",
    "msg-password-not-equals": "Le password non coincidono",
    "msg-received-access-request": "Hai ricevuto un'invio per accedere a {app-name} da un'altro dispositivo. Scarica l'app su Play Store su {0} e scansiona il qrcode, oppure clicca sul link\n\n{1}",
    "msg-recharge-success-balance": "Ricarica avvenuta con successo.\nNuovo saldo: **{0}**",
    "msg-refund-success": "Rimborso effettuato",
    "charge-new-card": "Ricarica nuova carta",
    "msg-register-device": "Stai accedendo con un nuovo dispositivo. Prima di procedere, è necessario registrare il dispositivo.",
    "msg-register-select-name": "Scegliere un nome appropriato e facilmente riconoscibile",
    "msg-reset-pin-requested": "Richiesta di reset PIN inviata. Controlla la tua email e segui le istruzioni per completare il reset.",
    "msg-scan-access-request": "il codice QR per accettare la richiesta di accesso",
    "msg-session-closed": "La tua sessione è scaduta. Eseguire di nuovo l'accesso",
    "msg-sign-up": "Crea un nuovo account",
    "msg-text-copied": "Invito copiato negli appunti",
    "msg-validate-otp": "Per completare l'accesso, inserire il codice OTP inviato via email a **{0}**",
    "msg-wait-for-card-pay": "per pagamento",
    "msg-wait-for-card-recharge": "per ricarica",
    "msg-wait-for-card-refund": "per rimborso",
    "msg-wait-for-card-verify": "per verifica",
    "msg-wait-for-card-write": "per formattazione",
    "msg-wait-for-card-read": "per lettura",
    "msg-wait-for-replace-card": "scansionare la nuova carta",
    "msg-wallet-not-protected": "Attenzione. La tua carta non è registrata, chiunque può accedere al tuo conto. Proteggilo ora",
    "msg-you-have-timeout": "Attenzione, hai {0} minuti per completare l'operazione",
    "name": "Nome",
    "never": "Mai",
    "next ❯": "Avanti ❯",
    "nfc": "Nfc",
    "nfc-card": "Carta NFC",
    "nfc-device": "Dispositivo NFC",
    "no": "No",
    "none": "Nessuno/a",
    "not-active": "Non attiva",
    "note": "Note",
    "online": "Online",
    "or-else": "oppure",
    "order": "Ordine",
    "order-count": "N° ordini",
    "order-list": "Ordini",
    "order-refund": "Storno",
    "order-report": "Report ordini",
    "order-type": "Tipo ordine",
    "orders-by": "{1} ordini per {0}",
    "os": "Sistema",
    "otp": "OTP",
    "owner": "Intestatario",
    "paid": "Pagato",
    "password": "Password",
    "payed": "Pagato",
    "payment": "Pagamento",
    "payment-method": "Metodo pagamento",
    "payment-type": "Tipo pagamento",
    "permissions": "Permessi",
    "personal": "Personale",
    "phone-number": "Cellulare",
    "pin": "Pin",
    "postal-code": "CAP",
    "price": "Prezzo",
    "print-receipt": "Stampa ricevuta",
    "private": "Privato",
    "product": "Prodotto",
    "product-create": "Crea prodotto",
    "product-issue": "Prodotto difettoso",
    "product-list": "Prodotti",
    "products": "Prodotti",
    "provider-trans-id": "Riferimento transazione",
    "qr-card": "Carta QR",
    "qr-code": "Codice QR",
    "reason": "Motivo",
    "recharge": "Ricarica",
    "recharge-card": "Ricarica carta",
    "refund": "Rimborso",
    "refund-action": "Rimborsa",
    "refund-card": "Rimborsa Carta",
    "refund-method": "Metodo rimborso",
    "refund-order": "{refund} {order}",
    "refunded": "Rimborsato",
    "register": "Registra",
    "register-device": "Registra dispositivo",
    "register-wallet": "Registra conto",
    "remember-me": "Ricordami",
    "repeat-password": "Ripeti password",
    "replace-card": "Sostituisci Carta",
    "resend-email": "Reinvia e-mail",
    "resend-otp": "Rinvia OTP",
    "reset": "Resetta",
    "reset-pin": "Reset PIN",
    "reset-the-card": "Resetta la carta",
    "retry": "Riprova",
    "root": "Radice",
    "sale-circuit": "Circuito vendita",
    "sale-circuit-options": "Opzioni circuito",
    "sale-point": "Punto vendita",
    "sale-point-list": "Punti vendita",
    "save": "Salva",
    "scan": "Scansiona",
    "scope-admin": "Amministratore",
    "scope-admin-desc": "Accesso completo a tutte le risorse autorizzate",
    "scope-charge": "Cassa",
    "scope-charge-desc": "Possibilità di ricaricare/rimborsare tessere",
    "scope-manage_products": "Gestione prodotti",
    "scope-manage_products-desc": "Possibilità di gestire prodotti e listini di prodotti",
    "scope-sell": "Venditore",
    "scope-sell-desc": "Possibilità di creare e consultare ordini di vendita",
    "security": "Sicurezza",
    "select": "Seleziona",
    "select-context": "Seleziona contesto",
    "select-formats": "Seleziona formati",
    "select-printer": "Seleziona Stampante",
    "select-product": "Seleziona prodotto",
    "sell": "Vendita",
    "service-not-provided": "Servizio non fornito",
    "session-closed": "Sessione chiusa",
    "session-list": "Sessioni",
    "settings": "Impostazioni",
    "share": "Condividi",
    "sign-up": "Crea account",
    "specify-address": "Inserisci indirizzo",
    "sps-active": "Attivo",
    "status": "Stato",
    "street-name": "Via",
    "tax-code": "P.IVA / CF",
    "time-label": "Periodo",
    "to-date": "a",
    "to-date-art": "al",
    "today": "Oggi",
    "toggle-theme": "Cambia tema",
    "tomorrow": "Domani",
    "total": "Totale",
    "type": "Tipo",
    "type-business": "Aziendale",
    "un-centiliters": "Centilitri",
    "un-grams": "Grammi",
    "un-hectogram": "Etti",
    "un-kilogram": "Kili",
    "un-liters": "Litri",
    "un-pieces": "Pezzi",
    "un-portion": "Porzioni",
    "un-slice": "Fette",
    "unblock-card": "Sblocca carta",
    "unit": "Unità",
    "unit-value": "Quantità",
    "unknown": "Sconosciuto",
    "unspecified": "Non specificato",
    "use-custom-currency": "Usa valuta personale",
    "username": "Utente",
    "validate": "Convalida",
    "validate-otp": "Convalida OTP",
    "validation": "Validazione",
    "wait-for-card": "In attesa della carta",
    "wait-for-payment": "In attesa di pagamento",
    "wallet": "Portafoglio",
    "wallet-report": "Report portafogli",
    "warn-close-wallet": "Attenzione, chiudendo il conto non sarà più possibile eseguire alcuna operazione in futuro.",
    "warn-no-delete-archive": "Impossibile eliminare, {0} in uso. Archiviare invece?",
    "warning": "Attenzione",
    "week": "Settimana",
    "with-balance": "Con credito",
    "withdrawal": "Prelievo",
    "sale-point-name": "Nome punto vendita",
    "without-balance": "Senza credito",
    "wr-total-active-cards": "Carte attive",
    "wr-total-active-cards-with-balance": "Carte attive con saldo",
    "wr-total-balance": "Attivo circolante",
    "wr-total-buy": "Totale acquisti",
    "wr-total-charged": "Totale ricariche",
    "wr-total-created": "Portafogli creati",
    "wr-total-refunded": "Totale rimborso carte",
    "wr-total-remain": "Attivo circolante",
    "wr-total-reset": "Totale non rimborsato",
    "wr-total-transactions": "Transazioni totali",
    "wrong-amount": "Importo errato",
    "year": "Anno",
    "yes": "Si",
    "❮ prev": "❮ Indietro",
    "reports": "Report",
    "desc-order-report": "Dettaglio temporale ordini raggruppato per prodotto, commerciante, punto vendita",
    "desc-wallet-report": "Dettaglio contabile conti creati e carte emesse",
    "desc-session-list": "Sessioni aperte dall'utente corrente nei avri dispositivi",
    "desc-device-list": "Elenco dei dispositivi in cui l'utente ha effettuato / delegato l'accesso",
    "desc-log-out": "Disconnette l'utente corrente dal sistema",
    "not-now": "Non ora",
    "exclude-gifts": "Escludi carte con regali",
    "err-invalid-card-sale-circuit": "La carta appartiene ad un altro circuito di vendita",
    "service-sum-up": "SumUp",
    "pair-device": "Accoppia dispositivo",
    "friendly-name": "Nome",
    "connect-provider": "Conneti a {0}",
    "merchant-services": "Servizi commerciante",
    "desc-merchant-services": "Configura i servizi esterni del commerciante, come gateway pagamento o pos",
    "connect-new": "Connetti servizio",
    "msg-select-service": "Seleziona uno dei servizi tra quelli elencati qui sotto",
    "msg-no-service-found": "Nessun servizio trovato",
    "add-item": "Aggiungi {0}",
    "msg-service-already-added": "Servizio già aggiunto",
    "err-pairing-failed": "Accoppiamento fallito",
    "pay-app-charge": "PayApp Ricarica",
    "bank-pos": "Pos Bancario",
    "err-generic-bank-pos": "Errore durante il pagamento con il POS",
    "ignore": "Ignora",
    "err-auth-failed-or-cancelled": "Autorizzazione fallita o operazione annullata",
    "msg-account-connected": "Account connesso"
}, { lang: "IT" })

